import IEC61131 from "../../images/systemComponents/IEC61131.png";
import SCADALogic from "../../images/SCADALogic.png";
import SCADALogicAVIF from "../../images/SCADALogic.avif";
import Layout from "../../components/mainPage/Layout";
import { AppRoute } from "../../constants";
import { HighlightedCode } from "shared/components/HighlightedCode";


export const Page = () => {
    const stCode = `VAR
CurrentTemp: REAL; // Текущая температура. Входной сигнал, получаемый от устройства
Output: REAL; // Выходное значение ПИД-регулятора. Выходной сигнал, передаваемый в устройство.
//Локальные переменные:
Error, Integral, Derivative, PreviousError: REAL;
Setpoint: REAL := 100.0; // Уставка температуры
Kp, Ki, Kd: REAL := 1.0, 0.1, 0.01; // Коэффициенты ПИД-регулятора
END_VAR

// Расчёт ошибки
Error := Setpoint - CurrentTemp;

// Расчёт интегральной составляющей
Integral := Integral + Error;

// Расчёт дифференциальной составляющей
Derivative := Error - PreviousError;

// Расчёт выходного значения
Output := Kp * Error + Ki * Integral + Kd * Derivative;

// Обновление предыдущей ошибки
PreviousError := Error;
        `
    return <Layout >
        <div className="container">
            <div className="article-container">
                <h1>
                    МЭК 61131 (Стандарт МЭК 61131-3: Языки программирования)
                </h1>
                <div className=" w-100 align-start d-flex flex-column">
                    <p >
                        Стандарт МЭК 61131 предназначен для обеспечения единого набора языков программирования для программируемых контроллеров и средств автоматизации производственных процессов, что позволяет упростить разработку и сопровождение программного обеспечения для автоматизации производственных процессов.
                    </p>
                    <p >
                        Основные цели и задачи стандарта МЭК 61131 включают:
                    </p>

                    <ul className="mb-4 description__list">
                        <li className="mb-1 description__number-li">Обеспечение единого синтаксиса и семантики для различных языков программирования, что упрощает обучение и понимание программного кода разработчиками.</li>
                        <li className="mb-1 description__number-li">Повышение переносимости программ между различными моделями и производителями программируемых контроллеров.</li>
                        <li className="mb-1 description__number-li">Обеспечение возможности структурирования программного кода для легкого понимания и сопровождения.</li>
                        <li className="mb-1 description__number-li">Поддержка различных типов задач автоматизации, включая управление процессами, обработку данных, коммуникацию и т.д.</li>
                        <li className="mb-1 description__number-li">Обеспечение возможности создания гибких и расширяемых систем управления.</li>
                    </ul>

                    <p>
                        SCADA NPT Expert поддерживает логические блоки <b>на всех языках стандарта МЭК 61131-3</b>:
                    </p>
                    <ul className="mb-4 description__list">
                        <li className="mb-1 description__number-li"><b>Структурированный текст</b> (ST - Structured Text)</li>
                        <li className="mb-1 description__number-li"><b>Последовательные функциональные схемы</b> (SFC - Sequential Function Chart)</li>
                        <li className="mb-1 description__number-li"><b>Диаграммы функциональных блоков</b> (FBD - Function Block Diagram)</li>
                        <li className="mb-1 description__number-li"><b>Релейно-контактные схемы, или релейные диаграммы</b> (LD - Ladder Diagram)</li>
                        <li className="mb-1 description__number-li"><b>Список инструкций</b> (IL - Instruction List)</li>
                    </ul>
                    <p>
                        Настройка и проверка логических блоков осуществляется с помощью продвинутого отладчика в <a href={`/${AppRoute.SCADAStudio}`} className="text-links">SCADA Studio</a>. Отладчик позволяет сформировать необходимый сценарий изменения входных переменных для контроля значений на выходе алгоритма.
                    </p>
                    <picture style={{ display: 'block', width: '100%' }} >
                        <source srcSet={SCADALogicAVIF} type="image/avif" />
                        <img
                            src={SCADALogic}
                            loading="lazy"
                            style={{ width: '100%', objectFit: 'cover', height: '100%', padding: '0' }}
                        ></img>
                    </picture>
                </div>
            </div>
        </div>
    </Layout>
}
export const meta = {
    title: 'МЭК 61131 (Стандарт МЭК 61131-3: Языки программирования)',
    description: 'Стандарт МЭК 61131 предназначен для обеспечения единого набора языков программирования для программируемых контроллеров и средств автоматизации производственных процессов, что позволяет упростить разработку и сопровождение программного обеспечения для автоматизации производственных процессов.'
}
